import React, { useState, useEffect } from 'react';
import soundManager from '../utils/soundEffects';
import { personalInfo } from '../data/mock';

const RetroHeader = ({ onNavigate }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    soundManager.init();
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="window mb-6">
      <div className="window-header">
        <span>🌟 Sreeja's Cyber Space 🌟</span>
        <div className="flex items-center gap-2">
          <span className="text-xs">{currentTime.toLocaleTimeString()}</span>
        </div>
      </div>
      <div className="window-body">
        <div className="text-center">
          <div className="mb-3 flex justify-center">
            <h1 className="text-5xl font-black pixel-text animate-pulse" style={{ 
              color: '#ff1493',
              textShadow: '2px 2px 0 #fff, 4px 4px 0 #ff69b4, 0 0 20px #ff69b4, 0 0 30px #ff1493, 0 0 40px #ff69b4'
            }}>
              ✨ Sreeja G ✨
            </h1>
          </div>
          <p className="text-lg mb-4">{personalInfo.title}</p>
          <div className="naruto-container">
            <img 
              src="https://media1.tenor.com/m/VnHIFsiGgY4AAAAd/naruto-run.gif" 
              alt="Naruto Run" 
              className="naruto-running"
            />
          </div>
        </div>
      </div>
      
      <style>{`
        .naruto-container {
          position: relative;
          width: 100%;
          height: 80px;
          overflow: hidden;
        }
        
        .naruto-running {
          position: absolute;
          height: 80px;
          width: auto;
          animation: narutoRun 5s linear infinite;
        }
        
        @keyframes narutoRun {
          0% {
            left: -100px;
          }
          100% {
            left: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default RetroHeader;
